export default __webpack_public_path__ + "static/media/group-8446.47c80bc8.png";